import { useEffect, useState } from "react";
import { Card } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import API from "../../common/API";

const RecordDireccionesVinculadas = (props: any) => {
    const { id } = props;
    const [records, setRecords] = useState<any>([]);
    const { t } = useTranslation();

    const bindRecords = async () => {
        try {
            const response = await API.getAction(`direccionesvinculadas/list?cedula=${id}`);
            if (response.status === 200) {
                setRecords(response.data.response || []);
            } else {
                console.error("Error fetching direcciones vinculadas records:", response.statusText);
            }
        } catch (error) {
            console.error("Error fetching direcciones vinculadas records:", error);
        }
    }

    useEffect(() => {
        if (id) {
            bindRecords();
        }
    }
        , [id]);
    if (records.length === 0) {
        return null;
    }

    return (<>
        <Card className="my-4" >
            <Card.Header className="display-4">{t("Direcciones relacionadas")}</Card.Header>
            <Card.Body className="p-0">
                <div className="table-responsive">
                    <table className="table table-striped table-bordered">
                        <thead>
                            <tr>
                                {/* <th>{t("Fuente")}</th> */}
                                <th>{t("Dirección")}</th>
                                <th>{t("Provincia")}</th>
                                <th>{t("Municipio")}</th>
                                <th>{t("Sector")}</th>
                                <th>{t("Fecha de referencia")}</th>
                            </tr>
                        </thead>
                        <tbody>
                            {records && records.map((item, index) => {
                                return (
                                    <tr key={index}>
                                        {/* <td>{item.fuente}</td> */}
                                        <td>{item.direccion}</td>
                                        <td>{item.provincia}</td>
                                        <td>{item.municipio}</td>
                                        <td>{item.sector}</td>
                                        <td>{item.fechaReferencia ? new Date(item.fechaReferencia).toLocaleDateString() : ""}</td>
                                    </tr>
                                );
                            })}
                        </tbody>
                    </table>
                </div>
            </Card.Body>
        </Card>
    </>
    );
};

export default RecordDireccionesVinculadas;
